module.exports = __webpack_public_path__ + "img/Convertible_Front.36a34abd.svg";